import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { CreateNewProjectRPC } from "./createNewProjectRPC";

export class CreateNewProjectRPCClientImpl extends CreateNewProjectRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: CreateNewProjectRPC.Request): Promise<LeoRPCResult<CreateNewProjectRPC.Response, CreateNewProjectRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/CreateNewProject",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      CreateNewProjectRPC.ResponseDTO,
      CreateNewProjectRPC.Errors.ErrorsDTO,
      CreateNewProjectRPC.Response,
      CreateNewProjectRPC.Errors.Errors
    >(
      response,
      "project/CreateNewProject",
      CreateNewProjectRPC.Response.fromDTO,
      CreateNewProjectRPC.Errors.fromDTO
    );
  }
}
